(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-order-catalogue"] && !Shopify.designMode) return;
  try {
    
(function () {
if (!customElements.get('rmr-side-view')) {customElements.define('rmr-side-view', class extends HTMLElement {
connectedCallback() {this.frame = requestAnimationFrame(() => {
const main = this.closest('article').querySelector('[data-b2b-product-link] img');
const img = this.querySelector('[data-side-image]'); const link = this.querySelector('[data-side-link]');
if (!main || !img || !link) return;
const versions = {'yellow-white':'1790221373','rose-white':'1790221383','yellow-black':'1790221388','rose-black':'1790221392'};
const sync = () => {const match = (main.getAttribute('src') || '').match(/R4240-(yellow|rose)-(white|black)\.png/); if (!match) return;
const key = match[1] + '-' + match[2]; const url = 'https://cdn.shopify.com/s/files/1/0738/8024/0438/files/R4240-side-' + key + '.png?v=' + versions[key];
if (img.getAttribute('src') !== url) img.src = url; link.href = url;};
this.observer = new MutationObserver(sync); this.observer.observe(main, {attributes:true, attributeFilter:['src']}); sync();});}
disconnectedCallback() {cancelAnimationFrame(this.frame); this.observer?.disconnect();}
});}
var stoneLabelMeasureContext = document.createElement('canvas').getContext('2d');
var stoneLabelResizeFrame;
function updateStoneSummaries(card) {
  card.querySelectorAll('[data-b2b-stone-select], [data-b2b-diamond-select], [data-b2b-central-select], [data-b2b-accent-select], [data-b2b-family-stone-select], [data-b2b-family-diamond-select]').forEach(function(select) {
    var summary = select.nextElementSibling;
    if (!summary || !summary.hasAttribute('data-b2b-selection-summary')) summary = null;
    if (select.hidden || select.getAttribute('aria-hidden') === 'true' || !select.getClientRects().length) {
      if (summary) summary.hidden = true;
      return;
    }
    var text = select.selectedOptions.length ? select.selectedOptions[0].textContent.trim() : '';
    var style = getComputedStyle(select);
    var availableWidth = select.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) - (style.appearance === 'none' ? 0 : 24);
    var clipped;
    if (stoneLabelMeasureContext) {
      stoneLabelMeasureContext.font = style.font || style.fontSize + ' ' + style.fontFamily;
      clipped = stoneLabelMeasureContext.measureText(text).width > availableWidth;
    } else {
      clipped = text.length > 36;
    }
    if (!summary && (!text || !clipped)) return;
    if (!summary) {
      summary = document.createElement('p');
      summary.className = 'b2b-orders__selection-summary';
      summary.setAttribute('data-b2b-selection-summary', '');
      summary.setAttribute('aria-hidden', 'true');
      summary.hidden = true;
      select.insertAdjacentElement('afterend', summary);
    }
    if (summary.textContent !== text) summary.textContent = text;
    summary.hidden = !text || !clipped;
  });
}
function refreshVisibleStoneSummaries() {
  document.querySelectorAll('[data-b2b-order-card], [data-b2b-order-family-card]').forEach(function(card) {
    if (card.dataset.b2bInitialized && card.getClientRects().length) updateStoneSummaries(card);
  });
}
window.addEventListener('resize', function() {
  cancelAnimationFrame(stoneLabelResizeFrame);
  stoneLabelResizeFrame = requestAnimationFrame(refreshVisibleStoneSummaries);
});
if (document.fonts && document.fonts.ready) document.fonts.ready.then(refreshVisibleStoneSummaries);

  function readB2BVariants(data) {
    var payload = JSON.parse(data.textContent);
    if (Array.isArray(payload)) return payload;
    function decode(row, group) {
      return Object.assign({}, group || {}, {
        id: row[0], diamond: row[1], gold: row[2], purity: row[3],
        priceCents: row[4], available: row[5], image: row[6],
        wornImage: group ? group.wornImage : row[7], currency: payload.currency
      });
    }
    if (payload.groups) return payload.groups.reduce(function (all, group) {
      var info = Object.assign({}, group);
      delete info.variants;
      return all.concat(group.variants.map(function (row) { return decode(row, info); }));
    }, []);
    return payload.variants.map(function (row) { return decode(row); });
  }
  function formatB2BMoney(cents, currency) {
    return new Intl.NumberFormat((document.documentElement.lang || '').indexOf('fr') === 0 ? 'fr-CA' : 'en-CA', {
      style: 'currency', currency: currency || 'CAD', currencyDisplay: 'code'
    }).format(Number(cents) / 100);
  }
  function initializeCollections(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-collection-tab]'));
    if (!tabs.length || tabs[0].dataset.collectionsReady) return;
    tabs[0].dataset.collectionsReady = 'true';
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-collection-panel]'));
    function activate(key, changeHash, refreshSearch) {
      if (!tabs.some(function(tab) { return tab.dataset.b2bCollectionTab === key; })) key = 'exclusive';
      root.__b2bCollection = key;
      root.querySelectorAll('.b2b-orders__ring-menu').forEach(function(menu) { menu.open = false; });
      tabs.forEach(function(tab) { var selected = tab.dataset.b2bCollectionTab === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
      panels.forEach(function(panel) { panel.hidden = panel.dataset.b2bCollectionPanel !== key; });
      root.querySelectorAll('[data-b2b-nav-scope]').forEach(function(link) { link.hidden = link.dataset.b2bNavScope !== key; });
      var input = root.querySelector('[data-b2b-catalog-search]');
      if (input) { input.placeholder = 'R4190 / R4430 / P842'; if (refreshSearch !== false) input.dispatchEvent(new Event('input', { bubbles: true })); }
      if (changeHash) history.replaceState(null, '', '#b2b-collection-' + key);
      window.dispatchEvent(new Event('resize'));
    }
    root.__b2bActivateCollection = activate;
    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() { activate(tab.dataset.b2bCollectionTab, true); });
      tab.addEventListener('keydown', function(event) {
        var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
        if (next < 0) return;
        event.preventDefault(); tabs[next].focus(); activate(tabs[next].dataset.b2bCollectionTab, true);
      });
    });
    function fromHash() { activate(location.hash.indexOf('atelier') !== -1 ? 'atelier' : 'exclusive', false); }
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  function initializeNavigation(root) {
    var nav = root.querySelector('.b2b-orders__catalog-nav');
    var summary = root.querySelector('[data-b2b-cart-summary]');
    if (!nav || nav.dataset.navigationReady) return;
    nav.dataset.navigationReady = 'true';
    var navigationVersion = 0;
    function cancelAlignment() { navigationVersion += 1; }
    window.addEventListener('wheel', cancelAlignment, { passive: true });
    window.addEventListener('touchstart', cancelAlignment, { passive: true });
    window.addEventListener('keydown', cancelAlignment);
    function measure() {
      var header = document.querySelector('#shopify-section-header');
      var headerHeight = header && !header.classList.contains('shopify-section-header-hidden') ? header.getBoundingClientRect().height : 0;
      var scope = nav.closest('.b2b-orders') || nav.parentElement;
      scope.style.setProperty('--b2b-header-height', headerHeight + 'px');
      scope.style.setProperty('--b2b-nav-height', nav.getBoundingClientRect().height + 'px');
      scope.style.setProperty('--b2b-cart-height', summary ? summary.getBoundingClientRect().height + 'px' : '0px');
    }
    nav.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      nav.querySelectorAll('.b2b-orders__ring-menu[open]').forEach(function(menu) { menu.open = false; menu.querySelector('summary').focus(); });
    });
    document.addEventListener('click', function(event) {
      if (!nav.contains(event.target)) nav.querySelectorAll('.b2b-orders__ring-menu').forEach(function(menu) { menu.open = false; });
    });
    measure();
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(measure);
      [nav, summary, document.querySelector('#shopify-section-header')].filter(Boolean).forEach(function (element) { observer.observe(element); });
    }
    var header = document.querySelector('#shopify-section-header');
    if (header) new MutationObserver(measure).observe(header, { attributes: true, attributeFilter: ['class'] });
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#b2b-category-"]');
      if (!link) return;
      var target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      nav.querySelectorAll('.b2b-orders__ring-menu').forEach(function(menu) { menu.open = false; });
      if (!target.getClientRects().length) {
        cancelAlignment();
        var search = root.querySelector('[data-b2b-catalog-search]');
        if (search) search.focus({ preventScroll: true });
        return;
      }
      var heading = target.querySelector('h2');
      if (heading) heading.focus({ preventScroll: true });
      measure();
      var targetY = target.getBoundingClientRect().top + window.scrollY;
      var headerOffset = header ? header.getBoundingClientRect().height : 0;
      var offset = headerOffset + nav.getBoundingClientRect().height + (summary ? summary.getBoundingClientRect().height : 0) + 16;
      window.scrollTo({ top: Math.max(0, targetY - offset), behavior: 'instant' });
      var version = ++navigationVersion;
      function alignDestination(frame) {
        if (version !== navigationVersion) return;
        measure();
        var stackBottom = Math.max(nav.getBoundingClientRect().bottom, summary ? summary.getBoundingClientRect().bottom : 0);
        var overlap = stackBottom + 16 - target.getBoundingClientRect().top;
        if (overlap > 1) window.scrollBy({ top: -overlap, behavior: 'instant' });
        if (frame < 4) requestAnimationFrame(function () { alignDestination(frame + 1); });
      }
      requestAnimationFrame(function () { alignDestination(0); });
      history.replaceState(null, '', link.hash);
    });
    window.addEventListener('resize', measure);
  }
  function initializeSearch(root) {
    var input = root.querySelector('[data-b2b-catalog-search]');
    if (!input || input.dataset.b2bSearchInitialized) return;
    input.dataset.b2bSearchInitialized = 'true';
    var clear = root.querySelector('[data-b2b-search-clear]');
    var count = root.querySelector('[data-b2b-search-count]');

    function normalize(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    function update() {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-search]'));
      var categories = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-category]'));
      var query = normalize(input.value.trim());
      var visible = 0;
      if (query) {
        var matches = cards.filter(function(card) { return normalize(card.dataset.b2bSearch).indexOf(query) !== -1; });
        var currentHasMatch = matches.some(function(card) { var panel = card.closest('[data-b2b-collection-panel]'); return !panel || panel.dataset.b2bCollectionPanel === root.__b2bCollection; });
        if (!currentHasMatch && matches.length && root.__b2bActivateCollection) {
          var targetPanel = matches[0].closest('[data-b2b-collection-panel]');
          if (targetPanel) root.__b2bActivateCollection(targetPanel.dataset.b2bCollectionPanel, true, false);
        }
      }
      var searchUrl = new URL(location.href);
      if (query) searchUrl.searchParams.set('b2b_search', input.value.trim());
      else searchUrl.searchParams.delete('b2b_search');
      history.replaceState(history.state, '', searchUrl.pathname + searchUrl.search + searchUrl.hash);
      cards.forEach(function (card) {
        var panel = card.closest("[data-b2b-collection-panel]");
        var inCollection = !panel || panel.dataset.b2bCollectionPanel === (root.__b2bCollection || "exclusive");
        var match = inCollection && (!query || normalize(card.dataset.b2bSearch).indexOf(query) !== -1);
        card.hidden = !match;
        if (match) {
          visible += 1;
          if (query && typeof card.__b2bInitialize === 'function') card.__b2bInitialize();
          if (query && typeof card.__b2bSelectReference === 'function') card.__b2bSelectReference(query);
        }
      });
      categories.forEach(function (category) {
        var hasVisibleCard = category.querySelector('[data-b2b-search]:not([hidden])');
        category.hidden = Boolean(query) && !hasVisibleCard;
        var categoryCount = category.querySelector('[data-b2b-category-count]');
        if (categoryCount) {
          var visibleInCategory = category.querySelectorAll('[data-b2b-search]:not([hidden])').length;
          categoryCount.textContent = query
            ? visibleInCategory + ' ' + (visibleInCategory === 1 ? categoryCount.dataset.countSingular : categoryCount.dataset.countPlural)
            : categoryCount.dataset.defaultCount;
        }
      });
      clear.hidden = !query;
      count.hidden = !query;
      if (!query) {
        count.textContent = '';
      } else if (!visible) {
        var paginationScope = root.querySelector('[data-b2b-pagination-scope]');
        var paginationStatus = root.querySelector('[data-b2b-pagination-status]');
        count.textContent = paginationScope && paginationScope.dataset.b2bPaginationState !== 'complete' && paginationStatus ? (paginationScope.dataset.b2bPaginationState === 'error' ? paginationStatus.dataset.error : paginationStatus.dataset.loading) : input.dataset.resultNone;
      } else {
        count.textContent = visible + ' ' + (visible === 1 ? input.dataset.resultSingular : input.dataset.resultPlural);
      }
    }
    input.value = new URL(location.href).searchParams.get('b2b_search') || input.value;
    input.addEventListener('input', update);
    clear.addEventListener('click', function () {
      input.value = '';
      update();
      input.focus();
    });
    update();
  }

  function initializeCartSummary(root) {
    var summary = root.querySelector('[data-b2b-cart-summary]');
    if (!summary || summary.dataset.b2bCartSummaryInitialized) return;
    summary.dataset.b2bCartSummaryInitialized = 'true';
    var itemCount = summary.querySelector('[data-b2b-cart-item-count]');
    var itemLabel = summary.querySelector('[data-b2b-cart-item-label]');
    var subtotal = summary.querySelector('[data-b2b-cart-subtotal]');
    var feedback = root.querySelector('[data-b2b-cart-feedback]');
    root.__b2bCartRevision = root.__b2bCartRevision || 0;
    var initialRevision = root.__b2bCartRevision;
    function formatTotal(cart) {
      var cents = Number(cart && cart.total_price);
      if (!Number.isFinite(cents)) return '';
      var currency = cart && cart.currency ? cart.currency : 'CAD';
      return formatB2BMoney(cents, currency);
    }
    function render(cart) {
      if (!cart || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0 || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return;
      var count = cart.item_count;
      if (itemCount) itemCount.textContent = String(count);
      if (itemLabel) itemLabel.textContent = count === 1 ? summary.dataset.itemSingular : summary.dataset.itemPlural;
      if (subtotal) {
        var total = formatTotal(cart);
        if (total) subtotal.textContent = total;
      }
    }
    root.__b2bAnnounceCartAdd = function (message) {
      if (!feedback) return;
      feedback.textContent = message || '';
      feedback.hidden = !message;
    };
    document.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.cart) {
        root.__b2bCartRevision += 1;
        render(event.detail.cart);
      }
    });
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (cart) {
      if (root.__b2bCartRevision === initialRevision) render(cart);
    }).catch(function () {});
  }


  function restoreProductSelection(root) {
    var params = new URL(location.href).searchParams;
    var productId = params.get('b2b_product');
    if ((!productId && !params.get('variant')) || root.__b2bProductRestored) return;
    var card = Array.prototype.find.call(root.querySelectorAll('[data-b2b-order-card], [data-b2b-order-family-card]'), function (element) {
      if (productId) return element.dataset.b2bProductId === productId;
      var data = element.querySelector('[data-b2b-variant-data], [data-b2b-family-variant-data]');
      return data && readB2BVariants(data).some(function(v) { return String(v.id) === params.get('variant'); });
    });
    if (!card) return;
    root.__b2bProductRestored = true;
    if (typeof card.__b2bInitialize === 'function') card.__b2bInitialize();
    var panel = card.closest('[data-b2b-collection-panel]');
    var tab = panel && root.querySelector('[data-b2b-collection-tab="' + panel.dataset.b2bCollectionPanel + '"]');
    if (tab) tab.click();
    var search = root.querySelector('[data-b2b-catalog-search]');
    if (search) {
      search.value = params.get('b2b_search') || card.dataset.b2bSearch;
      search.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var family = card.hasAttribute('data-b2b-order-family-card');
    var prefix = family ? 'data-b2b-family-' : 'data-b2b-';
    var data = card.querySelector('[' + prefix + 'variant-data]');
    var variants = data ? readB2BVariants(data) : [];
    var variant = variants.find(function (value) { return String(value.id) === params.get('variant'); });
    if (variant) {
      var stone = card.querySelector('[' + prefix + 'stone-select]');
      if (stone && variant.stone) stone.value = variant.stone;
      ['diamond', 'gold', 'purity'].forEach(function (name) {
        var field = card.querySelector('[' + prefix + name + '-select]');
        if (field && Array.prototype.some.call(field.options, function (option) { return option.value === variant[name]; })) field.value = variant[name];
      });
      var gold = card.querySelector('[' + prefix + 'gold-select]');
      var central = card.querySelector('[' + prefix + 'central-select]'), accent = card.querySelector('[' + prefix + 'accent-select]');
      if (central && accent) { var parts = variant.diamond.split(' | '); central.value = parts[0]; accent.value = parts[1]; }
      if (gold) gold.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var size = card.querySelector('[data-b2b-ring-size]');
    if (size && params.has('ring_size')) {
      var requested = params.get('ring_size');
      if (Array.prototype.some.call(size.options, function (option) { return option.value === requested; })) {
        size.value = requested;
        size.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (size) size.focus({ preventScroll: true });
    (size || card).scrollIntoView({ block: 'center' });
  }

  function initializeCard(root, card) {
      if (card.dataset.b2bInitialized) return;
      var family = card.hasAttribute('data-b2b-order-family-card');
      var prefix = family ? 'data-b2b-family-' : 'data-b2b-';
      function field(name) { return card.querySelector('[' + prefix + name + ']'); }
      var form = card.querySelector('form');
      var id = field('variant-id'), price = field('selected-price'), button = field('submit');
      var productCode = button ? button.dataset.b2bProductCode || '' : '';
      var data = field('variant-data'), status = card.querySelector('[data-b2b-form-status]');
      var diamond = field('diamond-select'), gold = field('gold-select'), purity = field('purity-select');
      var central = field('central-select'), accent = field('accent-select');
      var stone = family ? field('stone-select') : null;
      var details = family ? field('stone-details') : null;
      var links = card.querySelectorAll('[' + prefix + 'product-link]');
      var image = card.querySelector('.b2b-orders__image img');
      var worn = card.querySelector('[data-b2b-worn]');
      var wornImage = card.querySelector('[data-b2b-worn-image]');
      var wornLink = card.querySelector('[data-b2b-worn-link]');
      var wornLabel = card.querySelector('[data-b2b-worn-label]');
      if (!form || !id || !price || !button || !status) return;
      var carousel = card.querySelector('.b2b-carousel__controls');
      if (carousel) {
        var carouselProduct = productCode || (card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : '');
        var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
        var previousLabel = isFrench ? 'Image précédente' : 'Previous image';
        var nextLabel = isFrench ? 'Image suivante' : 'Next image';
        var previousButton = carousel.querySelector('[data-carousel-prev]');
        var nextButton = carousel.querySelector('[data-carousel-next]');
        if (previousButton) previousButton.setAttribute('aria-label', previousLabel + (carouselProduct ? (isFrench ? ' de ' : ' of ') + carouselProduct : ''));
        if (nextButton) nextButton.setAttribute('aria-label', nextLabel + (carouselProduct ? (isFrench ? ' de ' : ' of ') + carouselProduct : ''));
      }
      id.disabled = true;
      id.value = '';
      button.disabled = true;
      var variants = [];
      var pending = false;
      var lockedControls = [];
      var uncertainAdd = null;
      var resilienceData = root.querySelector('[data-b2b-resilience]');
      var resilience = resilienceData ? JSON.parse(resilienceData.textContent) : {};
      function setButtonLabel(label) {
        button.textContent = label;
        button.setAttribute('aria-label', productCode ? label + ' ' + productCode : label);
      }
      function fail(message) {
        if (worn) worn.hidden = true;
        id.value = '';
        id.setAttribute('value', '');
        id.disabled = true;
        button.disabled = true;
        setButtonLabel(message);
        status.classList.remove('b2b-orders__form-status--success');
        price.textContent = '—';
        status.textContent = message;
        status.hidden = false;
        return null;
      }
      function wornSrcset(url) {
        if (!url || url.indexOf('/files/') === -1) return '';
        return [360, 540, 720].map(function (width) {
          var resized = new URL(url, location.origin); resized.searchParams.set('width', width); return resized.href + ' ' + width + 'w';
        }).join(', ');
      }
      function selected() {
        if (!diamond || !gold || !purity || (family && !stone)) return null;
        return variants.find(function (v) {
          return v.diamond === (central && accent ? central.value + ' | ' + accent.value : diamond.value) && v.gold === gold.value && v.purity === purity.value && (!family || v.stone === stone.value);
        });
      }
      function sync() {
        if (pending || uncertainAdd) return selected();
        function constrain(select, values) {
          if (!select) return;
          Array.prototype.forEach.call(select.options, function(option) { option.disabled = values.indexOf(option.value) === -1; option.hidden = option.disabled; });
          if (!values.includes(select.value) && values.length) select.value = Array.prototype.find.call(select.options, function(option) { return !option.disabled; }).value;
        }
        var eligible = variants.filter(function(v) { return v.available && (!family || v.stone === stone.value) && v.diamond === (central && accent ? central.value + ' | ' + accent.value : diamond.value); });
        constrain(gold, eligible.map(function(v) { return v.gold; }));
        constrain(purity, eligible.filter(function(v) { return v.gold === gold.value; }).map(function(v) { return v.purity; }));
        updateStoneSummaries(card);
        var v = selected();
        if (!v || !v.available) return fail(status.dataset.unavailable);
        id.value = String(v.id);
        id.setAttribute('value', String(v.id));
        id.disabled = false;
        price.textContent = formatB2BMoney(v.priceCents, v.currency);
        button.disabled = false;
        if (family && v.reference) {
          productCode = v.reference;
          var heading = card.querySelector('h3');
          if (heading) heading.textContent = v.reference;
        }
        setButtonLabel(status.dataset.submitLabel);
        status.classList.remove('b2b-orders__form-status--success');
        status.hidden = true;
        if (details) details.textContent = v.stoneDetails || '';
        links.forEach(function (link) {
          var url = new URL(v.productUrl || link.getAttribute('href'), window.location.origin);
          url.searchParams.set('variant', String(v.id));
          var ringSizeLink = card.querySelector('[data-b2b-ring-size]');
          if (ringSizeLink) url.searchParams.set('ring_size', ringSizeLink.value);
          if (card.dataset.b2bPreviewTheme) url.searchParams.set('preview_theme_id', card.dataset.b2bPreviewTheme);
          link.href = url.pathname + url.search + url.hash;
          if (v.stoneTitle) link.setAttribute('aria-label', v.stoneTitle);
        });
        if (image) {
          var src = v.colorImage || v.image;
          if (src) image.src = src;
          var srcset = v.imageSrcset || wornSrcset(src);
          if (srcset) image.setAttribute('srcset', srcset);
          else image.removeAttribute('srcset');
          if (v.stoneTitle) image.alt = v.stoneTitle;
        }
        if (worn && wornImage && wornLink && wornLabel) {
          var wrongGold = !/^(or jaune|yellow gold)$/i.test(v.gold);
          worn.hidden = !v.wornImage || wrongGold;
          var wornSlide = worn.closest('.b2b-carousel__slide');
          if (wornSlide) wornSlide.hidden = worn.hidden;
          if (v.wornImage) {
            wornImage.src = v.wornImage;
            var srcset = wornSrcset(v.wornImage);
            if (srcset) wornImage.setAttribute('srcset', srcset);
            else wornImage.removeAttribute('srcset');
            wornLink.href = v.wornImage;
            var productHeading = card.querySelector('h3');
            var wornTitle = v.stoneTitle || (productHeading ? productHeading.textContent.trim() : '');
            wornImage.alt = wornImage.dataset.wornDescription + (wornTitle ? ' — ' + wornTitle : '');
            wornLink.setAttribute('aria-label', wornImage.alt);
            wornLabel.textContent = wornTitle || '';
          }
        }
        return v;
      }
      function cartPath() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      }
      function lineProperties(properties) {
        return Object.keys(properties || {}).sort().filter(function (key) {
          return properties[key] !== null && String(properties[key]) !== '';
        }).map(function (key) { return [key, String(properties[key])]; });
      }
      function matchesAddition(line, addition) {
        var price = line && (line.final_price === undefined ? line.price : line.final_price);
        return line && String(line.variant_id || line.id) === addition.id && Number.isSafeInteger(line.quantity) && line.quantity > 0 && Number.isSafeInteger(price) && price > 0 && JSON.stringify(lineProperties(line.properties)) === JSON.stringify(lineProperties(addition.properties));
      }
      function cartQuantity(cart, addition) {
        return cart.items.reduce(function (total, line) { return total + (matchesAddition(line, addition) ? line.quantity : 0); }, 0);
      }
      function requestCartJSON(url, options) {
        var controller = new AbortController();
        var deadline;
        var request = Promise.resolve().then(function () {
          return fetch(url, Object.assign({}, options, { signal: controller.signal }));
        }).then(function (response) {
          return response.json().then(function (data) { return { ok: response.ok, data: data }; });
        });
        var timeout = new Promise(function (resolve, reject) {
          deadline = setTimeout(function () {
            controller.abort();
            reject(new Error(resilience.uncertain));
          }, 20000);
        });
        return Promise.race([request, timeout]).finally(function () { clearTimeout(deadline); });
      }
      function readCart() {
        return requestCartJSON(cartPath() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (response) {
          if (!response.ok) throw new Error(resilience.uncertain);
          var cart = response.data;
          if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0 || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || cart.items.some(function (line) { return !line || !Number.isSafeInteger(line.quantity) || line.quantity <= 0 || !/^\d+$/.test(String(line.variant_id || line.id)); }) || cart.items.reduce(function (count, line) { return count + line.quantity; }, 0) !== cart.item_count) throw new Error(resilience.uncertain);
          return cart;
        });
      }
      function publishCart(cart, revision) {
        if (revision !== (root.__b2bCartRevision || 0)) return;
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (element) {
          element.textContent = String(cart.item_count);
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      }
      function updateCartBubble() {
        var revision = root.__b2bCartRevision || 0;
        readCart().then(function (cart) { publishCart(cart, revision); }).catch(function () {});
      }
      function restoreControls() {
        pending = false;
        lockedControls.forEach(function (control) { control.disabled = false; });
        lockedControls = [];
        button.disabled = false;
        setButtonLabel(status.dataset.submitLabel);
        if (root.__b2bCartAddOwner === card) root.__b2bCartAddOwner = null;
      }
      function confirmAddition(addition, cart, revision) {
        uncertainAdd = null;
        status.textContent = addition.message || status.dataset.success;
        status.classList.add('b2b-orders__form-status--success');
        status.hidden = false;
        if (typeof root.__b2bAnnounceCartAdd === 'function') root.__b2bAnnounceCartAdd(status.textContent);
        if (cart) publishCart(cart, revision);
        else updateCartBubble();
        restoreControls();
      }
      function showUncertain(message) {
        pending = false;
        button.disabled = false;
        setButtonLabel(resilience.retryCheck);
        status.classList.remove('b2b-orders__form-status--success');
        status.textContent = message;
        var link = document.createElement('a');
        link.href = cartPath() + 'cart';
        link.textContent = resilience.openCart;
        status.appendChild(document.createTextNode(' '));
        status.appendChild(link);
        status.hidden = false;
      }
      function reconcileAddition() {
        if (!uncertainAdd || pending) return;
        pending = true;
        button.disabled = true;
        status.textContent = resilience.checking;
        status.hidden = false;
        var addition = uncertainAdd;
        var revision = root.__b2bCartRevision || 0;
        readCart().then(function (cart) {
          if (revision !== (root.__b2bCartRevision || 0)) { showUncertain(resilience.notConfirmed); return; }
          if (cartQuantity(cart, addition) >= addition.beforeQuantity + addition.quantity) {
            confirmAddition(addition, cart, revision);
          } else {
            publishCart(cart, revision);
            showUncertain(resilience.notConfirmed);
          }
        }).catch(function () { showUncertain(resilience.uncertain); });
      }
      function buildCartAddMessage(v) {
        var quantityField = card.querySelector('[name="quantity"]');
        var quantity = quantityField ? Math.max(1, Number(quantityField.value) || 1) : 1;
        var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
        function selectedLabel(select) {
          return select && !select.hidden && select.selectedOptions.length ? select.selectedOptions[0].textContent.trim() : '';
        }
        var ringSize = card.querySelector('[data-b2b-ring-size]');
        var sizeLabel = ringSize ? (isFrench ? 'Taille ' : 'Size ') + selectedLabel(ringSize) : '';
        var selection = [selectedLabel(stone), selectedLabel(diamond), selectedLabel(central), selectedLabel(accent), selectedLabel(gold), selectedLabel(purity), sizeLabel].filter(Boolean).join(' · ');
        var message = isFrench
          ? productCode + ' · ' + selection + ' · ' + quantity + ' ' + (quantity === 1 ? 'article ajouté' : 'articles ajoutés') + ' au panier — ' + formatB2BMoney(v.priceCents * quantity, v.currency) + ' (total)'
          : productCode + ' · ' + selection + ' · ' + quantity + ' ' + (quantity === 1 ? 'item added' : 'items added') + ' to cart — ' + formatB2BMoney(v.priceCents * quantity, v.currency) + ' (total)';
        return message;
      }
      var ringSizeControl = card.querySelector('[data-b2b-ring-size]');
      if (ringSizeControl) ringSizeControl.addEventListener('change', sync);
      form.addEventListener('submit', function (event) {
        if (pending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        if (uncertainAdd) {
          event.preventDefault(); event.stopImmediatePropagation();
          reconcileAddition();
          return;
        }
        if (root.__b2bCartAddOwner && root.__b2bCartAddOwner !== card) {
          event.preventDefault(); event.stopImmediatePropagation();
          status.classList.remove('b2b-orders__form-status--success');
          status.textContent = resilience.busy;
          status.hidden = false;
          return;
        }
        if (!form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        var v = sync();
        if (!v || id.disabled || id.value !== String(v.id)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          status.hidden = false;
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        var endpoint = form.getAttribute('action') || '/cart/add';
        if (endpoint.indexOf('.js') === -1) endpoint += '.js';
        var payload = new FormData(form);
        var addition = { id: String(v.id), quantity: Number(payload.get('quantity') || 1), properties: {}, message: buildCartAddMessage(v) };
        payload.forEach(function (value, key) {
          var property = /^properties\[(.+)\]$/.exec(key);
          if (property) addition.properties[property[1]] = String(value);
        });
        if (!Number.isSafeInteger(addition.quantity) || addition.quantity < 1) return;
        pending = true;
        root.__b2bCartAddOwner = card;
        lockedControls = Array.prototype.filter.call(form.querySelectorAll('select, input:not([type=hidden])'), function (control) { return !control.disabled; });
        lockedControls.forEach(function (control) { control.disabled = true; });
        button.disabled = true;
        status.classList.remove('b2b-orders__form-status--success');
        status.textContent = resilience.checking;
        status.hidden = false;
        readCart().then(function (cart) {
          addition.beforeQuantity = cartQuantity(cart, addition);
          root.__b2bCartRevision = (root.__b2bCartRevision || 0) + 1;
          uncertainAdd = addition;
          status.textContent = status.dataset.adding;
          return requestCartJSON(endpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: payload }).then(function (response) {
            var data = response.data;
            var line = data && Array.isArray(data.items) && data.items.length === 1 ? data.items[0] : data;
            if (!response.ok || !matchesAddition(line, addition) || line.quantity < addition.quantity) throw new Error(resilience.uncertain);
            return line;
          });
        }).then(function () {
          confirmAddition(addition);
        }).catch(function () {
          if (uncertainAdd) {
            pending = false;
            reconcileAddition();
          } else {
            status.textContent = resilience.readFailed;
            status.classList.remove('b2b-orders__form-status--success');
            status.hidden = false;
            restoreControls();
          }
        });
      }, true);
      try {
        if (!data || !diamond || !gold || !purity || (family && (!stone || !details))) throw new Error('Missing selection');
        variants = readB2BVariants(data);
        if (!Array.isArray(variants) || !variants.length || variants.some(function (v) {
          return !v || !Number.isSafeInteger(v.id) || v.id <= 0 || typeof v.available !== 'boolean' || !Number.isFinite(v.priceCents) || typeof v.diamond !== 'string' || typeof v.gold !== 'string' || typeof v.purity !== 'string' || (family && typeof v.stone !== 'string');
        })) throw new Error('Invalid variants');
      } catch (error) {
        variants = [];
        fail(status.dataset.error);
        return;
      }
      [stone, diamond, central, accent, gold, purity].filter(Boolean).forEach(function (select) {
        select.addEventListener('change', sync);
        select.addEventListener('input', sync);
      });
      card.__b2bSelectReference = function (reference) {
        if (!family) return;
        var matches = variants.filter(function (v) { return v.reference && v.reference.toLowerCase() === reference; });
        var keys = Array.from(new Set(matches.map(function (v) { return v.stone; })));
        if (keys.length === 1 && stone.value !== keys[0]) {
          stone.value = keys[0];
          sync();
        }
      };
      function rank(v) {
        return (/lab|laboratoire/i.test(v.diamond) ? 0 : 100) + (/jaune|yellow/i.test(v.gold) ? 0 : 10) + (v.purity === '10K' ? 0 : v.purity === '14K' ? 1 : 2);
      }
      var initial = variants.filter(function(v) {
        return v.available && (!family || v.stone === stone.value) && Array.prototype.some.call(diamond.options, function(option) { return option.value === v.diamond; });
      }).sort(function(a,b) { return rank(a) - rank(b); })[0];
      if (initial) {
        diamond.value = initial.diamond; gold.value = initial.gold; purity.value = initial.purity;
        if (central && accent) { var components = initial.diamond.split(' | '); central.value = components[0]; accent.value = components[1]; }
      }
      [diamond, gold].filter(Boolean).forEach(function(select) {
        var current = select.value;
        Array.prototype.slice.call(select.options).sort(function(a,b) {
          var pattern = select === gold ? /jaune|yellow/i : /lab|laboratoire/i;
          return Number(pattern.test(b.value)) - Number(pattern.test(a.value));
        }).forEach(function(option) { select.appendChild(option); });
        select.value = current;
      });
      card.dataset.b2bInitialized = 'true';
      sync();
      window.addEventListener('pageshow', sync);
  }
  function translateOptionLabels(root) {
    if ((document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0) return;
    var translations = [["Noir naturel traité", "Treated natural black diamonds"], ["diamants noirs naturels traités", "treated natural black diamonds"], ["Diamants noirs naturels traités", "Treated natural black diamonds"], ["Diamants de laboratoire blancs", "White lab-grown diamonds"], ["Diamants naturels blancs", "White natural diamonds"], ["Diamants blancs · laboratoire", "White lab-grown diamonds"], ["Diamants blancs · naturels", "White natural diamonds"], ["Diamants de laboratoire", "Lab-grown diamonds"], ["Diamant laboratoire", "Lab-grown diamond"], ["Diamants laboratoire", "Lab-grown diamonds"], ["diamants laboratoire", "lab-grown diamonds"], ["Diamants naturels", "Natural diamonds"], ["diamants naturels", "natural diamonds"], ["Diamants naturel", "Natural diamonds"], ["Laboratoire", "Lab-grown"], ["Naturel", "Natural"], ["Améthystes", "Amethysts"], ["Améthyste", "Amethyst"], ["Topaze bleue", "Blue topaz"], ["Topaze London Blue", "London Blue topaz"], ["Citrine ronde", "Round citrine"], ["Prasiolite verte", "Green prasiolite"], ["Or blanc et jaune", "White and yellow gold"], ["Or jaune et blanc", "Yellow and white gold"], ["chacun", "each"]];
    root.querySelectorAll('[data-b2b-order-card] select option, [data-b2b-order-family-card] select option').forEach(function(option) {
      var label = option.textContent;
      translations.forEach(function(pair) { label = label.split(pair[0]).join(pair[1]); });
      option.textContent = label.replace(/(\d),(\d)/g, '$1.$2');
    });
  }
  function initializeCataloguePages(root) {
    var scope = root.querySelector('[data-b2b-pagination-scope]');
    if (!scope || scope.__b2bPagination) return;
    var status = root.querySelector('[data-b2b-pagination-status]');
    var message = status && status.querySelector('[data-b2b-pagination-message]');
    var retry = status && status.querySelector('[data-b2b-pagination-retry]');
    var categories = Array.prototype.slice.call(scope.querySelectorAll('[data-b2b-atelier-page]'));
    var state = { running: false, complete: false, categories: [] };
    scope.__b2bPagination = state;
    function cardsIn(grid) { return Array.prototype.slice.call(grid.children).filter(function(card) { return card.matches('[data-b2b-search]'); }); }
    function identity(card) { return card.dataset.b2bProductId; }
    function refresh() {
      var input = root.querySelector('[data-b2b-catalog-search]');
      if (input) input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function announce(mode) {
      scope.dataset.b2bPaginationState = mode;
      if (status) status.hidden = mode === 'complete';
      if (message && status) message.textContent = mode === 'error' ? status.dataset.error : status.dataset.loading;
      if (retry) retry.hidden = mode !== 'error';
      scope.setAttribute('aria-busy', mode === 'loading' ? 'true' : 'false');
      refresh();
    }
    function nextPage() {
      var next = null;
      state.categories.forEach(function(category) {
        for (var page = 1; page <= category.pages; page += 1) {
          if (!category.loaded.has(page) && (next === null || page < next)) { next = page; break; }
        }
      });
      return next;
    }
    function validateComplete() {
      return state.categories.every(function(category) {
        var cards = cardsIn(category.grid);
        var ids = cards.map(identity);
        return cards.length === category.count && ids.every(Boolean) && new Set(ids).size === ids.length;
      });
    }
    try {
      categories.forEach(function(element) {
        var page = Number(element.dataset.b2bAtelierPage);
        var pages = Number(element.dataset.b2bAtelierPages);
        var count = Number(element.dataset.b2bAtelierCount);
        var grid = element.querySelector('.b2b-orders__grid');
        var param = element.dataset.b2bAtelierPageParam;
        if (!grid || !param || !Number.isSafeInteger(page) || page < 1 || !Number.isSafeInteger(pages) || pages < 0 || pages > 100 || !Number.isSafeInteger(count) || count < 0 || count > 25000) throw new Error('Invalid catalogue pagination');
        var loaded = new Set();
        if (page <= pages) loaded.add(page);
        cardsIn(grid).forEach(function(card) { card.dataset.b2bCataloguePage = String(page); });
        state.categories.push({ element: element, key: element.dataset.b2bCategory, grid: grid, pages: pages, count: count, param: param, loaded: loaded });
      });
      if (!state.categories.length) throw new Error('Missing catalogue categories');
    } catch (error) {
      state.invalid = true;
      announce('error');
      if (retry) retry.addEventListener('click', function() { location.reload(); });
      return;
    }
    async function run() {
      if (state.running || state.complete) return;
      state.running = true;
      announce('loading');
      try {
        var page;
        while ((page = nextPage()) !== null) {
          var needed = state.categories.filter(function(category) { return page <= category.pages && !category.loaded.has(page); });
          var params = Array.from(new Set(needed.map(function(category) { return category.param; })));
          if (params.length !== 1) throw new Error('Inconsistent catalogue pagination');
          var url = new URL(location.href);
          url.hash = '';
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', scope.dataset.b2bPaginationSection);
          url.searchParams.set(params[0], String(page));
          var response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Catalogue request failed');
          var html = await response.text();
          var documentPage = new DOMParser().parseFromString(html, 'text/html');
          var incomingScope = documentPage.querySelector('[data-b2b-pagination-scope]');
          if (!incomingScope || incomingScope.dataset.b2bPaginationSection !== scope.dataset.b2bPaginationSection) throw new Error('Catalogue access unavailable');
          var additions = needed.map(function(category) {
            var incoming = Array.prototype.find.call(incomingScope.querySelectorAll('[data-b2b-atelier-page]'), function(candidate) { return candidate.dataset.b2bCategory === category.key; });
            if (!incoming || Number(incoming.dataset.b2bAtelierPage) !== page || Number(incoming.dataset.b2bAtelierPages) !== category.pages || Number(incoming.dataset.b2bAtelierCount) !== category.count) throw new Error('Catalogue changed while loading');
            var incomingGrid = incoming.querySelector('.b2b-orders__grid');
            if (!incomingGrid) throw new Error('Missing catalogue page');
            var cards = cardsIn(incomingGrid);
            var expected = Math.min(250, category.count - (page - 1) * 250);
            if (cards.length !== expected || cards.some(function(card) { return !identity(card); })) throw new Error('Incomplete catalogue page');
            return { category: category, cards: cards };
          });
          additions.forEach(function(addition) {
            var category = addition.category;
            var known = new Set(cardsIn(category.grid).map(identity));
            var before = cardsIn(category.grid).find(function(card) { return Number(card.dataset.b2bCataloguePage) > page; }) || null;
            addition.cards.forEach(function(card) {
              if (known.has(identity(card))) return;
              known.add(identity(card));
              card.dataset.b2bCataloguePage = String(page);
              category.grid.insertBefore(card, before);
            });
            category.loaded.add(page);
          });
          initialize(root);
          refresh();
        }
        if (!validateComplete()) throw new Error('Catalogue inventory mismatch');
        state.complete = true;
        announce('complete');
        restoreProductSelection(root);
      } catch (error) {
        announce('error');
      } finally {
        state.running = false;
      }
    }
    if (retry) retry.addEventListener('click', run);
    if (nextPage() === null && validateComplete()) {
      state.complete = true;
      announce('complete');
      return;
    }
    run();
  }

  function initialize(root) {
    translateOptionLabels(root);
    initializeNavigation(root);
    initializeCartSummary(root);
    var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.__b2bInitialize();
      });
    }, { rootMargin: '400px 0px' }) : null;
    root.querySelectorAll('[data-b2b-order-card], [data-b2b-order-family-card]').forEach(function (card) {
      if (card.__b2bInitialize) return;
      card.__b2bInitialize = function () {
        initializeCard(root, card);
        if (observer) observer.unobserve(card);
      };
      card.addEventListener('focusin', card.__b2bInitialize, { once: true });
      if (observer) observer.observe(card);
      else card.__b2bInitialize();
    });
    initializeCollections(root);
    initializeCataloguePages(root);
    initializeSearch(root);
    restoreProductSelection(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmr-r4113-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatB2BMoney(cents, currency) {
    return new Intl.NumberFormat((document.documentElement.lang || '').indexOf('fr') === 0 ? 'fr-CA' : 'en-CA', {
      style: 'currency', currency: currency || 'CAD', currencyDisplay: 'code'
    }).format(Number(cents) / 100);
  }
  function initializeCollections(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-collection-tab]'));
    if (!tabs.length || tabs[0].dataset.collectionsReady) return;
    tabs[0].dataset.collectionsReady = 'true';
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-collection-panel]'));
    function activate(key, changeHash) {
      if (!tabs.some(function(tab) { return tab.dataset.b2bCollectionTab === key; })) key = 'exclusive';
      root.__b2bCollection = key;
      tabs.forEach(function(tab) { var selected = tab.dataset.b2bCollectionTab === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
      panels.forEach(function(panel) { panel.hidden = panel.dataset.b2bCollectionPanel !== key; });
      root.querySelectorAll('[data-b2b-nav-scope]').forEach(function(link) { link.hidden = link.dataset.b2bNavScope !== key; });
      var input = root.querySelector('[data-b2b-catalog-search]');
      if (input) { input.value = ''; input.placeholder = key === 'atelier' ? 'R4113 / R4220' : 'R4430 / P842'; input.dispatchEvent(new Event('input', { bubbles: true })); }
      if (changeHash) history.replaceState(null, '', '#b2b-collection-' + key);
      window.dispatchEvent(new Event('resize'));
    }
    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() { activate(tab.dataset.b2bCollectionTab, true); });
      tab.addEventListener('keydown', function(event) {
        var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
        if (next < 0) return;
        event.preventDefault(); tabs[next].focus(); activate(tabs[next].dataset.b2bCollectionTab, true);
      });
    });
    function fromHash() { activate(location.hash.indexOf('atelier') !== -1 ? 'atelier' : 'exclusive', false); }
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  function initializeNavigation(root) {
    var nav = root.querySelector('.b2b-orders__catalog-nav');
    var summary = root.querySelector('[data-b2b-cart-summary]');
    if (!nav || nav.dataset.navigationReady) return;
    nav.dataset.navigationReady = 'true';
    function measure() {
      var header = document.querySelector('#shopify-section-header');
      var headerHeight = header && !header.classList.contains('shopify-section-header-hidden') ? header.getBoundingClientRect().height : 0;
      var scope = nav.closest('.b2b-orders') || nav.parentElement;
      scope.style.setProperty('--b2b-header-height', headerHeight + 'px');
      scope.style.setProperty('--b2b-nav-height', nav.getBoundingClientRect().height + 'px');
      scope.style.setProperty('--b2b-cart-height', summary ? summary.getBoundingClientRect().height + 'px' : '0px');
    }
    measure();
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(measure);
      [nav, summary, document.querySelector('#shopify-section-header')].filter(Boolean).forEach(function (element) { observer.observe(element); });
    }
    var header = document.querySelector('#shopify-section-header');
    if (header) new MutationObserver(measure).observe(header, { attributes: true, attributeFilter: ['class'] });
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#b2b-category-"]');
      if (!link) return;
      var target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      var search = root.querySelector('[data-b2b-catalog-search]');
      if (search && search.value) { search.value = ''; search.dispatchEvent(new Event('input', { bubbles: true })); }
      measure();
      var targetY = target.getBoundingClientRect().top + window.scrollY;
      var headerOffset = header ? header.getBoundingClientRect().height : 0;
      var offset = headerOffset + nav.getBoundingClientRect().height + (summary ? summary.getBoundingClientRect().height : 0) + 16;
      window.scrollTo({ top: Math.max(0, targetY - offset), behavior: 'instant' });
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        measure();
        if (header && header.classList.contains('shopify-section-header-hidden')) {
          var stackBottom = summary ? summary.getBoundingClientRect().bottom : nav.getBoundingClientRect().bottom;
          var extra = target.getBoundingClientRect().top - stackBottom - 16;
          if (extra > 1) window.scrollBy({ top: extra, behavior: 'instant' });
        }
      }); });
      history.replaceState(null, '', link.hash);
    });
    window.addEventListener('resize', measure);
  }
  function initializeSearch(root) {
    var input = root.querySelector('[data-b2b-catalog-search]');
    if (!input || input.dataset.b2bSearchInitialized) return;
    input.dataset.b2bSearchInitialized = 'true';
    var clear = root.querySelector('[data-b2b-search-clear]');
    var count = root.querySelector('[data-b2b-search-count]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-search]'));
    var categories = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-category]'));
    function normalize(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    function update() {
      var query = normalize(input.value.trim());
      var visible = 0;
      cards.forEach(function (card) {
        var panel = card.closest("[data-b2b-collection-panel]");
        var inCollection = !panel || panel.dataset.b2bCollectionPanel === (root.__b2bCollection || "exclusive");
        var match = inCollection && (!query || normalize(card.dataset.b2bSearch).indexOf(query) !== -1);
        card.hidden = !match;
        if (match) {
          visible += 1;
          if (query && typeof card.__b2bSelectReference === 'function') card.__b2bSelectReference(query);
        }
      });
      categories.forEach(function (category) {
        var hasVisibleCard = category.querySelector('[data-b2b-search]:not([hidden])');
        category.hidden = Boolean(query) && !hasVisibleCard;
        var categoryCount = category.querySelector('[data-b2b-category-count]');
        if (categoryCount) {
          var visibleInCategory = category.querySelectorAll('[data-b2b-search]:not([hidden])').length;
          categoryCount.textContent = query
            ? visibleInCategory + ' ' + (visibleInCategory === 1 ? categoryCount.dataset.countSingular : categoryCount.dataset.countPlural)
            : categoryCount.dataset.defaultCount;
        }
      });
      clear.hidden = !query;
      count.hidden = !query;
      if (!query) {
        count.textContent = '';
      } else if (!visible) {
        count.textContent = input.dataset.resultNone;
      } else {
        count.textContent = visible + ' ' + (visible === 1 ? input.dataset.resultSingular : input.dataset.resultPlural);
      }
    }
    input.addEventListener('input', update);
    clear.addEventListener('click', function () {
      input.value = '';
      update();
      input.focus();
    });
    update();
  }

  function initializeCartSummary(root) {
    var summary = root.querySelector('[data-b2b-cart-summary]');
    if (!summary || summary.dataset.b2bCartSummaryInitialized) return;
    summary.dataset.b2bCartSummaryInitialized = 'true';
    var itemCount = summary.querySelector('[data-b2b-cart-item-count]');
    var itemLabel = summary.querySelector('[data-b2b-cart-item-label]');
    var subtotal = summary.querySelector('[data-b2b-cart-subtotal]');
    var feedback = root.querySelector('[data-b2b-cart-feedback]');
    function formatTotal(cart) {
      var cents = Number(cart && cart.total_price);
      if (!Number.isFinite(cents)) return '';
      var currency = cart && cart.currency ? cart.currency : 'CAD';
      return formatB2BMoney(cents, currency);
    }
    function render(cart) {
      if (!cart) return;
      var count = Number(cart.item_count) || 0;
      if (itemCount) itemCount.textContent = String(count);
      if (itemLabel) itemLabel.textContent = count === 1 ? summary.dataset.itemSingular : summary.dataset.itemPlural;
      if (subtotal) {
        var total = formatTotal(cart);
        if (total) subtotal.textContent = total;
      }
    }
    root.__b2bAnnounceCartAdd = function (message) {
      if (!feedback) return;
      feedback.textContent = message || '';
      feedback.hidden = !message;
    };
    document.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.cart) render(event.detail.cart);
    });
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(render).catch(function () {});
  }

  function initialize(root) {
    initializeNavigation(root);
    initializeCartSummary(root);
    root.querySelectorAll('[data-b2b-order-card], [data-b2b-order-family-card]').forEach(function (card) {
      if (card.dataset.b2bInitialized) return;
      var family = card.hasAttribute('data-b2b-order-family-card');
      var prefix = family ? 'data-b2b-family-' : 'data-b2b-';
      function field(name) { return card.querySelector('[' + prefix + name + ']'); }
      var form = card.querySelector('form');
      var id = field('variant-id'), price = field('selected-price'), button = field('submit');
      var productCode = button ? button.dataset.b2bProductCode || '' : '';
      var data = field('variant-data'), status = card.querySelector('[data-b2b-form-status]');
      var diamond = field('diamond-select'), gold = field('gold-select'), purity = field('purity-select');
      var central = field('central-select'), accent = field('accent-select');
      var stone = family ? field('stone-select') : null;
      var details = family ? field('stone-details') : null;
      var links = card.querySelectorAll('[' + prefix + 'product-link]');
      var image = card.querySelector('.b2b-orders__image img');
      var worn = card.querySelector('[data-b2b-worn]');
      var wornImage = card.querySelector('[data-b2b-worn-image]');
      var wornLink = card.querySelector('[data-b2b-worn-link]');
      var wornLabel = card.querySelector('[data-b2b-worn-label]');
      if (!form || !id || !price || !button || !status) return;
      var carousel = card.querySelector('.b2b-carousel__controls');
      if (carousel) {
        var carouselProduct = productCode || (card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : '');
        var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
        var previousLabel = isFrench ? 'Image précédente' : 'Previous image';
        var nextLabel = isFrench ? 'Image suivante' : 'Next image';
        var previousButton = carousel.querySelector('[data-carousel-prev]');
        var nextButton = carousel.querySelector('[data-carousel-next]');
        if (previousButton) previousButton.setAttribute('aria-label', previousLabel + (carouselProduct ? ' de ' + carouselProduct : ''));
        if (nextButton) nextButton.setAttribute('aria-label', nextLabel + (carouselProduct ? ' de ' + carouselProduct : ''));
      }
      id.disabled = true;
      id.value = '';
      button.disabled = true;
      var variants = [];
      function setButtonLabel(label) {
        button.textContent = label;
        button.setAttribute('aria-label', productCode ? label + ' ' + productCode : label);
      }
      function fail(message) {
        if (worn) worn.hidden = true;
        id.value = '';
        id.setAttribute('value', '');
        id.disabled = true;
        button.disabled = true;
        setButtonLabel(message);
        status.classList.remove('b2b-orders__form-status--success');
        price.textContent = '—';
        status.textContent = message;
        status.hidden = false;
        return null;
      }
      function wornSrcset(url) {
        if (!url || url.indexOf('/files/') === -1 || url.indexOf('?v=') === -1) return '';
        return [360, 540, 720].map(function (width) {
          return url.replace('?v=', '?width=' + width + '&v=') + ' ' + width + 'w';
        }).join(', ');
      }
      function selected() {
        if (!diamond || !gold || !purity || (family && !stone)) return null;
        return variants.find(function (v) {
          return v.diamond === (central && accent ? central.value + ' | ' + accent.value : diamond.value) && v.gold === gold.value && v.purity === purity.value && (!family || v.stone === stone.value);
        });
      }
      function sync() {
        var v = selected();
        if (!v || !v.available) return fail(status.dataset.unavailable);
        id.value = String(v.id);
        id.setAttribute('value', String(v.id));
        id.disabled = false;
        price.textContent = formatB2BMoney(v.priceCents, v.currency);
        button.disabled = false;
        if (family && v.reference) {
          productCode = v.reference;
          var heading = card.querySelector('h3');
          if (heading) heading.textContent = v.reference;
        }
        setButtonLabel(status.dataset.submitLabel);
        status.classList.remove('b2b-orders__form-status--success');
        status.hidden = true;
        if (details) details.textContent = v.stoneDetails || '';
        links.forEach(function (link) {
          var url = new URL(v.productUrl || link.getAttribute('href'), window.location.origin);
          url.searchParams.set('variant', String(v.id));
          if (card.dataset.b2bPreviewTheme) url.searchParams.set('preview_theme_id', card.dataset.b2bPreviewTheme);
          link.href = url.pathname + url.search + url.hash;
          if (v.stoneTitle) link.setAttribute('aria-label', v.stoneTitle);
        });
        if (image) {
          var src = v.colorImage || v.image;
          if (src) image.src = src;
          var srcset = v.colorImage ? '' : v.imageSrcset;
          if (srcset) image.setAttribute('srcset', srcset);
          else image.removeAttribute('srcset');
          if (v.stoneTitle) image.alt = v.stoneTitle;
        }
        if (worn && wornImage && wornLink && wornLabel) {
          worn.hidden = !v.wornImage;
          if (v.wornImage) {
            wornImage.src = v.wornImage;
            var srcset = wornSrcset(v.wornImage);
            if (srcset) wornImage.setAttribute('srcset', srcset);
            else wornImage.removeAttribute('srcset');
            wornLink.href = v.wornImage;
            var productHeading = card.querySelector('h3');
            var wornTitle = v.stoneTitle || (productHeading ? productHeading.textContent.trim() : '');
            wornImage.alt = wornImage.dataset.wornDescription + (wornTitle ? ' — ' + wornTitle : '');
            wornLink.setAttribute('aria-label', wornImage.alt);
            wornLabel.textContent = wornTitle || '';
          }
        }
        return v;
      }
      function updateCartBubble() {
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
          return response.ok ? response.json() : null;
        }).then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (element) {
            element.textContent = String(cart.item_count);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        }).catch(function () {});
      }
      function buildCartAddMessage(v) {
        var quantityField = card.querySelector('[name="quantity"]');
        var quantity = quantityField ? Math.max(1, Number(quantityField.value) || 1) : 1;
        var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
        function selectedLabel(select) {
          return select && !select.hidden && select.selectedOptions.length ? select.selectedOptions[0].textContent.trim() : '';
        }
        var ringSize = card.querySelector('[data-b2b-ring-size]');
        var sizeLabel = ringSize ? (isFrench ? 'Taille ' : 'Size ') + selectedLabel(ringSize) : '';
        var selection = [selectedLabel(stone), selectedLabel(diamond), selectedLabel(central), selectedLabel(accent), selectedLabel(gold), selectedLabel(purity), sizeLabel].filter(Boolean).join(' · ');
        var message = isFrench
          ? productCode + ' · ' + selection + ' · ' + quantity + ' ' + (quantity === 1 ? 'article ajouté' : 'articles ajoutés') + ' au panier — ' + formatB2BMoney(v.priceCents, v.currency)
          : productCode + ' · ' + selection + ' · ' + quantity + ' ' + (quantity === 1 ? 'item added' : 'items added') + ' to cart — ' + formatB2BMoney(v.priceCents, v.currency);
        return message;
      }
      form.addEventListener('submit', function (event) {
        var v = sync();
        if (!v || id.disabled || id.value !== String(v.id)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          status.hidden = false;
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        var endpoint = form.getAttribute('action') || '/cart/add';
        if (endpoint.indexOf('.js') === -1) endpoint += '.js';
        var payload = new FormData(form);
        var addedMessage = buildCartAddMessage(v);
        button.disabled = true;
        status.classList.remove('b2b-orders__form-status--success');
        status.textContent = status.dataset.adding;
        status.hidden = false;
        fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: payload }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) throw new Error(data.description || status.dataset.error);
            return data;
          });
        }).then(function () {
          status.textContent = addedMessage || status.dataset.success;
          if (typeof root.__b2bAnnounceCartAdd === 'function') root.__b2bAnnounceCartAdd(status.textContent);
          status.classList.add('b2b-orders__form-status--success');
          status.hidden = false;
          button.disabled = false;
          setButtonLabel(status.dataset.submitLabel);
          updateCartBubble();
        }).catch(function (error) {
          status.textContent = error.message || status.dataset.error;
          status.classList.remove('b2b-orders__form-status--success');
          status.hidden = false;
          button.disabled = false;
          setButtonLabel(status.dataset.submitLabel);
        });
      }, true);
      try {
        if (!data || !diamond || !gold || !purity || (family && (!stone || !details))) throw new Error('Missing selection');
        variants = JSON.parse(data.textContent);
        if (!Array.isArray(variants) || !variants.length || variants.some(function (v) {
          return !v || !Number.isSafeInteger(v.id) || v.id <= 0 || typeof v.available !== 'boolean' || typeof v.price !== 'string' || !Number.isFinite(v.priceCents) || typeof v.diamond !== 'string' || typeof v.gold !== 'string' || typeof v.purity !== 'string' || (family && typeof v.stone !== 'string');
        })) throw new Error('Invalid variants');
      } catch (error) {
        variants = [];
        fail(status.dataset.error);
        return;
      }
      [stone, diamond, central, accent, gold, purity].filter(Boolean).forEach(function (select) {
        select.addEventListener('change', sync);
        select.addEventListener('input', sync);
      });
      card.__b2bSelectReference = function (reference) {
        if (!family) return;
        var matches = variants.filter(function (v) { return v.reference && v.reference.toLowerCase() === reference; });
        var keys = Array.from(new Set(matches.map(function (v) { return v.stone; })));
        if (keys.length === 1 && stone.value !== keys[0]) {
          stone.value = keys[0];
          sync();
        }
      };
      card.dataset.b2bInitialized = 'true';
      sync();
      window.addEventListener('pageshow', sync);
    });
    initializeCollections(root);
    initializeSearch(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();


  } catch(e) { console.error(e); }
})();
})();
